var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-divider'),_c('add-new-rtb-rule',{staticClass:"mt-5",attrs:{"single_rtbRule":_vm.single_rtbRule},on:{"create":function($event){return _vm.createRtbRule($event)},"update":function($event){return _vm.updateRule($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }